import { FunctionComponent } from 'react';

import { CompanyCDN } from '../../../utils/url';
import styles from './seel-logo.module.sass';

export interface SeelLogoHorizontal {
    hasPreviousBrand?: boolean;
}

const SeelLogoHorizontal: FunctionComponent<SeelLogoHorizontal> = ({ hasPreviousBrand = true }) => {
    return (
        // <div>
        //     <img
        //         style={{
        //             width: '100%',
        //         }}
        //         src={CompanyCDN.url('/assets/images/logo/Seel-Logo-2022-RGB-1inch.png')}
        //         alt="illustration"
        //     />
        //     {hasPreviousBrand ? (
        //         <div style={{ textAlign: 'right', color: 'black' }}>
        //             previously <strong>Kover</strong>
        //         </div>
        //     ) : null}
        // </div>
        <div className={styles.logo_wrapper}>
            <div className={styles.aboutRaSeelTitleLogo}>
                <img
                    className={styles.left_logo}
                    // style={{
                    //     display: 'flex',
                    // }}
                    src={CompanyCDN.url('/assets/images/about-ra/logo.png')}
                    alt="illustration"
                />
                <img
                    className={styles.right_logo}
                    // style={{
                    //     display: 'flex',
                    //     marginLeft: '20px',
                    // }}
                    src={CompanyCDN.url('/assets/images/about-ra/seel.png')}
                    alt="illustration"
                />
            </div>

            {hasPreviousBrand ? (
                <div
                    style={{
                        textAlign: 'right',
                        color: 'black',
                        fontSize: '18px',
                        lineHeight: '22px',
                        fontWeight: 400,
                    }}
                >
                    previously
                    <strong
                        style={{
                            fontWeight: 700,
                            paddingLeft: '10px',
                        }}
                    >
                        Kover
                    </strong>
                </div>
            ) : null}
        </div>
    );
};

export default SeelLogoHorizontal;
